import IconeDivergencia from '@/components/IconeDivergencia';
import IconeOrigem from '@/components/IconeOrigem';
import OrdemPreSessao from '@/components/OrdemPreSessao';
import SituacaoAlteracaoMinutaBusiness from '@/dominio/SituacaoAlteracaoMinutaBusiness';
import SegredoJustica from '@mui/icons-material/Lock';
import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/processo.css';
import Configuracao from '../../util/Configuracao';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import AbrirDialogComposicaoButton from '../shared/AbrirDialogComposicaoButton';
import AnotacaoCurtaSecretario from './AnotacaoCurtaSecretario';
import AtualizarDecisao from './AtualizarDecisao';
import CabecalhoProcessoOperacoesEmLote from './CabecalhoProcessoOperacoesEmLote';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import IncluirSustentacaoOral from './IncluirSustentacaoOral';
import OrdemSecretario from './OrdemSecretario';
import ParticipacaoAdvogado from './ParticipacaoAdvogado';
import PeticoesPendentes from './PeticoesPendentes';
import { MODULO } from './RecarregarCacheServidor';
import RecarregarCacheServidorDeUmProcesso from './RecarregarCacheServidorDeUmProcesso';
import ResultadoJulgamento from './ResultadoJulgamento';
import StatusMinuta from './StatusMinuta';
import ValidacaoPreSessao from './ValidacaoPreSessao';
import VotoAlteradoRelator from './VotoAlteradoRelator';
import IconeCorreJunto from './icones/IconeCorreJunto';
import IconeDestaque from './icones/IconeDestaque';
import IconeTipoJulgamento from './icones/IconeTipoJulgamento';

class FerramentasDetalhesProcessoPreSessao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            origemPJe: computed,
            handleClickNumeroProcesso: action,
            processoDiferenteDoApregoado: computed,
            isProcessoModal: computed,
            composicaoHabilitada: computed,
            quantidadeTotalDeProcessos: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get origemPJe() {
        return this.registro?.processo?.origem === Configuracao.ORIGEM_PJE;
    }

    handleClickNumeroProcesso = () => {
        const achou = this.store.processosSessao.find(
            (proc) => this.registro.processo.numeroCompleto === proc.processo.numeroCompleto
        );

        if (achou) {
            this.store.processoScroll = this.registro;
        } else {
            this.mensagemStore.abrirMensagemAlerta('Processo não está na lista.');
        }
    };

    get processoDiferenteDoApregoado() {
        return (
            this.sessaoStore.processoApregoado &&
            this.store.processoExpandido &&
            this.sessaoStore.processoApregoado.processo.numeroCompleto !==
                this.store.processoExpandido.processo.numeroCompleto
        );
    }

    get isProcessoModal() {
        return (
            this.store.processoModal &&
            this.store.processoModal.processo.numeroCompleto === this.registro.processo.numeroCompleto
        );
    }

    get composicaoHabilitada() {
        return this.registro.sessaoId;
    }

    get quantidadeTotalDeProcessos() {
        return this.store.processosSessao.length;
    }

    handleEditarDispositivo = async () => {
        if (this.salaSessaoStore.confirmarEdicaoVoto) {
            this.salaSessaoStore.abrirModalConfirmacaoEditarVoto();
        } else {
            await this.salaSessaoStore.recuperarUrlEdicaoVoto(this.registro);
            window.open(this.registro.informacoesAdicionais.urlEdicaoVoto);
        }
    };

    render() {
        return (
            <div
                id="divCabecalhoDetalhes"
                style={{ display: 'flex', justifyContent: 'space-between' }}
            >
                {this.renderCabecalhoDetalhes()}
                {this.renderFerramentas()}
            </div>
        );
    }

    renderCabecalhoDetalhes() {
        return this.isProcessoModal ? (
            <CabecalhoProcessoOperacoesEmLote
                consulta
                registro={this.registro}
            />
        ) : (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    maxHeight: '75px',
                    flexWrap: 'wrap',
                    marginBottom: '8px'
                }}
            >
                <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '4px 0px', alignItems: 'baseline' }}>
                    <OrdemPreSessao
                        ordem={this.registro.ordemPreSessao}
                        total={this.quantidadeTotalDeProcessos}
                    />
                    <Tooltip
                        placement="top"
                        title={
                            <>
                                {!!this.processoDiferenteDoApregoado && (
                                    <Typography>O processo em análise é diferente do processo apregoado.</Typography>
                                )}
                                <Typography>Selecionar o processo na lista.</Typography>
                            </>
                        }
                    >
                        <Box onClick={this.handleClickNumeroProcesso}>
                            <Typography
                                component="h3"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'nowrap',
                                    margin: '0px 0px 0px 6px',
                                    cursor: 'pointer'
                                }}
                            >
                                <Typography
                                    component="span"
                                    style={{
                                        fontSize: '17px',
                                        fontWeight: 'bold',
                                        color: this.processoDiferenteDoApregoado
                                            ? 'darkorange'
                                            : this.registro.segredoJustica
                                              ? red[900]
                                              : 'black'
                                    }}
                                >
                                    {this.processo.numeroCompleto}
                                </Typography>
                            </Typography>
                        </Box>
                    </Tooltip>
                    <div>
                        {!!this.registro.segredoJustica && (
                            <Tooltip
                                title={'SEGREDO DE JUSTIÇA'}
                                placement="top"
                            >
                                <SegredoJustica
                                    style={{
                                        height: '24px',
                                        width: '24px',
                                        marginLeft: '4px',
                                        marginRight: '4px',
                                        color: red[900]
                                    }}
                                />
                            </Tooltip>
                        )}
                    </div>
                </div>
                <div style={{ marginLeft: '4px', marginRight: '4px' }}>
                    <LabelNumeroProcesso
                        exibirIcone
                        habilitarCopiarNumero
                        registro={this.registro}
                    />
                </div>
                <Divider
                    sx={{ mx: 1 }}
                    orientation="vertical"
                    flexItem
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginLeft: 1,
                        gap: 2
                    }}
                >
                    <AnotacaoCurtaSecretario registro={this.registro} />
                    <OrdemSecretario
                        registro={this.registro}
                        componenteExibicao="FerramentasDetalhesProcessoPreSessao"
                    />
                    {!!this.parametroStore.isOrgaoTST && <IconeOrigem processo={this.processo} />}
                    <PeticoesPendentes registro={this.registro} />
                    <IconeDestaque registro={this.registro} />
                    <div
                        style={{
                            cursor: 'pointer',
                            display: this.registro.impedimentos ? 'flex' : 'none'
                        }}
                    >
                        <Impedimento
                            registro={this.registro}
                            isferramentaDetalhes={false}
                        />
                    </div>
                    <IconeTipoJulgamento
                        permiteAlterar={true}
                        registro={this.registro}
                    />
                    <ResultadoJulgamento registro={this.registro} />
                    <IconeCorreJunto processo={this.processo} />
                    <IconeDivergencia registro={this.registro} />
                    <IconesMagistradosProcesso
                        dense
                        espacamentoReduzido
                        registro={this.registro}
                    />
                </Box>
                {!!this.composicaoHabilitada && (
                    <Box sx={{ margin: '4px', px: '4px' }}>
                        <AbrirDialogComposicaoButton registro={this.registro} />
                    </Box>
                )}
                {this.renderStatusMinuta()}
                <Divider
                    sx={{ mx: 1 }}
                    orientation="vertical"
                    flexItem
                />
                <Box sx={{ mx: '4px', cursor: 'pointer' }}>
                    <ValidacaoPreSessao registro={this.registro} />
                </Box>
            </div>
        );
    }

    renderFerramentas() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: '10px',
                    justifyContent: 'flex-end',
                    flexWrap: 'wrap',
                    marginBottom: '8px'
                }}
            >
                <ParticipacaoAdvogado registro={this.registro} />
                <VotoAlteradoRelator registro={this.registro} />
                <AtualizarDecisao registro={this.registro} />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        height: '40px',
                        marginRight: '8px'
                    }}
                >
                    <IncluirSustentacaoOral registro={this.registro} />
                </div>
                <RecarregarCacheServidorDeUmProcesso
                    registro={this.registro}
                    modulo={MODULO.SALA_SESSAO}
                />
            </div>
        );
    }

    renderStatusMinuta() {
        const statusMinuta = SituacaoAlteracaoMinutaBusiness.getStatusMinuta(this.registro);

        if (!statusMinuta) {
            return null;
        }

        const estiloCursor = statusMinuta.onClickEnabled ? 'pointer' : 'default';

        return statusMinuta.onClickEnabled ? (
            <IconButton
                size="large"
                sx={{
                    height: '40px',
                    padding: '8px',
                    paddingTop: '12px',
                    cursor: estiloCursor
                }}
            >
                <StatusMinuta registro={this.registro} />
            </IconButton>
        ) : (
            <StatusMinuta
                registro={this.registro}
                apenasIcone
            />
        );
    }
}

export default inject('stores')(observer(FerramentasDetalhesProcessoPreSessao));
